export default __webpack_public_path__ + "static/media/foodz@3x.c58401c7.png";